import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewContainerRef } from '@angular/core';
import { HostDirective } from './host.directive';

@Component({
  standalone: false,
  selector: 'app-dynamic-component',
  template: ` <ng-template hostComponent></ng-template> `,
})
export class DynamicContentComponent implements OnInit, OnChanges {
  @Input() component: any;
  @Input() data: any;
  componentRef: any;

  @ViewChild(HostDirective, { static: true }) host!: HostDirective;

  constructor(public viewContainerRef: ViewContainerRef) {}
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && !changes.data.firstChange && (changes.data.currentValue?.length !== changes.data.previousValue?.length ||
      JSON.stringify(changes.data.currentValue) !== JSON.stringify(changes.data.previousValue))) {
        this.componentRef.instance.data = changes.data.currentValue;
      }
  }

  ngOnInit() {
    const viewContainerRef = this.host.viewContainerRef;
    viewContainerRef.clear();
    this.componentRef = viewContainerRef.createComponent(this.component as any);
    (<any>this.componentRef.instance).data = this.data;
  }
}
